// @ts-check
import Ajax from '@ln/ajax/ajax';

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json; charset=UTF-8'
};

class ApiBase {
  constructor(name, config, apiTarget = undefined) {
    const settings = typeof config === 'function' ? config() : config;

    this.target = apiTarget || {};
    this.reset();
    this.name = name;
    this.version = settings.version || 'v1';
    this.domain = settings.domain;
    this.defaultHeaders = DEFAULT_HEADERS;
    this.session = settings.session;
    const headers = settings.headers || {};
    if (!settings.token) throw new Error('config.token is undefined');
    else this.getToken = () => settings.token;

    if (!settings.session) throw new Error('config.session is undefined');

    Object.keys(headers).forEach((header) => {
      if (headers[header] === undefined) delete headers[header];
      else this.defaultHeaders[header] = headers[header];
    });
  }

  get tasks() { return this.target.tasks; }
  set tasks(value) { this.target.tasks = value; }

  init() {
    this.reset();
  }

  reset() {
    this.tasks = { urls: [] };
  }

  getURL(name = this.name, chunk = null) {
    let url = `${this.domain}`;
    if (name) url += `/${name}`;
    if (chunk) url += `/${chunk}`;

    return url;
  }

  getHeaders(headersBase = this.defaultHeaders) {
    const headers = headersBase || {};

    return new Promise((resolve, reject) => {
      try {
        headers['x-ln-token'] = this.getToken();
        headers['x-ln-session'] = this.session;
        headers['x-ln-api-version'] = this.version;

        resolve(headers);
      } catch (errorGetHeaders) {
        reject(errorGetHeaders);
      }
    });
  }

  addTask(name, chunkUrl, parameters) {
    const params = parameters === undefined ? chunkUrl : parameters;
    const chunk = parameters === undefined ? undefined : chunkUrl;

    const url = this.getURL(name, chunk);
    if (!this.tasks[url]) this.tasks.urls.push(url);
    this.tasks[url] = this.tasks[url] || { url, params: [], promise: [] };
    this.tasks[url].length = this.tasks[url].params.push(...params);

    const p = new Promise((resolve, reject) => this.tasks[url].promise.push({ resolve, reject }));

    return p;
  }

  execute() {
    return new Promise((resolve, reject) => {
      this.getHeaders()
        .then((headers) => {
          const tasksToRun = this.tasks;
          this.reset();

          if (tasksToRun.urls.length > 0) {
            tasksToRun.urls.forEach((url) => {
              const info = tasksToRun[url];
              Ajax.post(info.url, info.params, headers)
                .then((textResult) => {
                  try {
                    const result = JSON.parse(textResult);

                    if (result instanceof Array) {
                      result.forEach((r, i) => info.promise[i].resolve(r));

                      resolve(result);
                    } else if (typeof result === 'object') {
                      reject(result ? result.errorMessage : textResult);
                    } else {
                      reject(result);
                    }
                  } catch (err) {
                    reject(err);
                  }
                })
                .catch(reject);
            });
          } else {
            resolve(null);
          }
        })
        .catch(reject);
    });
  }
}

export default ApiBase;



// WEBPACK FOOTER //
// ./~/@ln/personalizacion/apibase.js